import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import {Spin} from 'antd';
import Calender from '../components/meeting/Index';

const Meeting = ({
  meeting,
  intl,
  dispatch,
  loading,
  account,
  top: topData,
  roomZone,
  login
}) => {
  return (
    <Spin spinning={loading} size="large">
      <Calender
        calendar={meeting}
        intl={intl}
        dispatch={dispatch}
        account={account}
        topData={topData}
        zoneTree={roomZone.zone}
        userInfo={login.userInfo}
      />
    </Spin>
  );
};

const mapStateToProps = state => {
  return { ...state, loading: state.loading.global };
};

export default connect(mapStateToProps)(injectIntl(Meeting));



// WEBPACK FOOTER //
// ./src/routes/Meeting.js